<div class="flex flex-col w-full space-y-2">
  <div class="flex flex-col w-full google_input" [class.field-invalid]="searchControl.invalid && searchControl.touched">
    @if (field?.props?.label) {
      <span class="mb-1">
        {{field.props.label}}
        @if (isFieldRequired) {
          <span class="mat-mdc-form-field-required-marker mdc-floating-label--required font-normal"></span>
        }
      </span>
    }
    <div #search class="w-full shadow-sm"></div>
  </div>

    <input matInput type="number" [formControl]="formControl" class="hidden">
  </div>
